export enum Direction {
  OUTBOUND = "OUTBOUND",
  INBOUND = "INBOUND",
  UPLOAD = "UPLOAD",
  DOWNLOAD = "DOWNLOAD",
}

export enum Operator {
  GT = "gt",
  LT = "lt",
  GTE = "gte",
  LTE = "lte",
}

export enum OutboundMessageType {
  TEXT = "text",
  EVENT = "event",
  ORDER = "order",
  POLL = "poll",
  CONTACT = "contact",
}
